<template>
    <section class="tekst pink">
        <circles-layout></circles-layout>
        <h1>Aantoonbare onderwijskwaliteit</h1>
        <p>In 2020 hebben we opnieuw een verbeterslag gemaakt op onze onderwijskwaliteit. We werkten aan het vergroten van eigenaarschap en verantwoordelijkheid. Dit hield een verschuiving in van directief naar gezamenlijke verantwoordelijkheid. Zo worden medewerkers uitgedaagd mee te denken met (cultuur)veranderingen. Verder staan teams meer in hun kracht en voelen ze daardoor meer verantwoordelijkheid. Bovendien wordt meer gewerkt met kleinere gefaciliteerde werkgroepen met vertegenwoordigers uit alle teams die onderwijsvernieuwingen uitwerken.</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'OnderwijskwaliteitIntro',
        meta: {
            title: 'OnderwijskwaliteitIntro',
            color: '#fe1362'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
            }
        }
    };
</script>
